import "./Login.css";
import { useAuth } from "../../auth/AuthProvider";

export default function Login() {
  const { login } = useAuth();

  return (
    <div className="login-container">
      <div className="loginBg" />
      <div className="login-box">
        <h2>easyzilla</h2>
        {login()}
      </div>
    </div>
  );
}
